{
  "REGISTER": {
    "TRY_WOOT": "Vytvořit účet",
    "TITLE": "Registrovat se",
    "TESTIMONIAL_HEADER": "Stačí jediný krok k pohybu vpřed",
    "TESTIMONIAL_CONTENT": "Jste jen krok od zapojení vašich zákazníků, jejich udržení a nalezení nových.",
    "TERMS_ACCEPT": "Vytvořením účtu souhlasíte s našimi <a href=\"https://chat.jarabot.com/terms\">Podmínkami použití</a> a <a href=\"https://chat.jarabot.com/privacy-policy\">Zásadami ochrany osobních údajů</a>",
    "TERMS_LINKS": "<a href=\"https://chat.jarabot.com/terms\">Podmínky služby</a> - <a href=\"https://chat.jarabot.com/privacy-policy\">Ochrana soukromí</a>",
    "OAUTH": {
      "GOOGLE_SIGNUP": "Přihlásit se pomocí Google"
    },
    "COMPANY_NAME": {
      "LABEL": "Název společnosti",
      "PLACEHOLDER": "Zadejte název vaší společnosti. např.: Wayne Enterprises",
      "ERROR": "Název společnosti je příliš krátký"
    },
    "FULL_NAME": {
      "LABEL": "Celé jméno",
      "PLACEHOLDER": "Zadejte celé jméno. např.: Jan Novák",
      "ERROR": "Celé jméno je příliš krátké"
    },
    "EMAIL": {
      "LABEL": "Pracovní e-mail",
      "PLACEHOLDER": "Zadejte svou pracovní e-mailovou adresu. např.: jan{'@'}novak.spolecnost",
      "ERROR": "Zadejte prosím platnou pracovní e-mailovou adresu"
    },
    "PASSWORD": {
      "LABEL": "Heslo",
      "PLACEHOLDER": "Heslo",
      "ERROR": "Heslo je příliš krátké",
      "IS_INVALID_PASSWORD": "Heslo by mělo obsahovat alespoň jedno velké písmeno, jedno malé písmeno, jedno číslo a jeden speciální znak"
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "Potvrzení hesla",
      "PLACEHOLDER": "Potvrzení hesla",
      "ERROR": "Heslo se neshoduje"
    },
    "API": {
      "SUCCESS_MESSAGE": "Registrace byla úspěšná",
      "ERROR_MESSAGE": "Nelze se připojit k chat serveru, opakujte akci později"
    },
    "SUBMIT": "Vytvořit účet",
    "HAVE_AN_ACCOUNT": "Máte již účet?"
  }
}
